import { compose } from 'redux';

import ActivationFormTariff
  from '../../components/compositions/activation/ActivationFormTariff';
import initForm from '../form/FormInitializer';

const component = compose(
  initForm(),
)(ActivationFormTariff);

export const id = 'tariff';

const isEnabled = (fieldMap, formValues) => {
  const simStatusResponse = formValues[fieldMap.simStatusResponse.name];
  return simStatusResponse && simStatusResponse.tariff;
};

/**
 * @return {FormConfig}
 */
export const mapStateToFormConfig = (state, props) => ({
  component,
  fieldMap: {},
  label: props.ui.guiWordTariff,
  isEnabled,
});

export default mapStateToFormConfig;
